import { takeLatest, call, put, fork } from 'redux-saga/effects';
import { loadIscilik, saveIscilik } from 'src/utils/storage/Labour';
import { distinct } from 'src/utils/Common';
import * as actions from '../actions/labourActions';
import * as api from '../api/afterSalesDataServices';

function* getLabours(kulModelKodu, garantiTipi, hizmetKodu, WorkOrderLabours,WorkOrderId) {
  try {
    if (!kulModelKodu.kulModelKodu) {
      throw new Error('Model Kodu Girilmemiş');
    }
    let data = loadIscilik(kulModelKodu.kulModelKodu);

    const result = yield call(
      api.getLabours,
      kulModelKodu,
      garantiTipi,
      hizmetKodu,
      WorkOrderId
    );
    data = result.data === '' ? [] : result.data;
    saveIscilik(kulModelKodu.kulModelKodu, data);
    let selectedlabours = {};
    var { WorkOrderLabours } = arguments[0];

    if (data.length > 0) {
      if (WorkOrderLabours) {
        const DistinctLabours = distinct(
          WorkOrderLabours.map(w => {
            return { DefectId: w.DefectId };
          })
        );
        DistinctLabours.forEach(function(h, index) {
          selectedlabours = { ...selectedlabours, [h.DefectId]: [] };
        });
        
        WorkOrderLabours.forEach(function(i, index) {
          selectedlabours[i.DefectId].push(i.LabourCode.toString());
          var tempIndex = data.findIndex(f=>f.LabourId === i.LabourId);
          if(tempIndex !== -1){
          const updatedItem = { ...data[tempIndex] };
            updatedItem.Price = i.LabourPrice;
            updatedItem.PriceWithWat =i.LabourPriceWithWat;

            data[tempIndex] = updatedItem;
          }
        });
      }
    }
    
    yield put(actions.getLabourSuccess(data, selectedlabours));
  } catch (error) {
    yield put(actions.setLabourError(error));
  }
}

function* watchGetLabourRequest() {
  yield takeLatest(actions.Types.GET_LABOUR_REQUEST, getLabours);
}

const labourSagas = [fork(watchGetLabourRequest)];

export default labourSagas;
